import { Divider as AntDivider } from 'antd';
import styled from 'styled-components';

export const CustomDivider = styled(AntDivider)`
    border-top: 1px solid var(--gray-4);
`;
